import { post } from './baseUrl';
import { ApiEndpoint } from './endpoints';

export type WebinyModel = 'endoZonePatientResource';

export const WEBINY_MODEL_END_ZONE_PATIENT_RESOURCE: WebinyModel =
  'endoZonePatientResource';

export interface AddConsumerContentRequest {
  entryId: string;
  tenancyId: number;
  caremapprAppUserId: string;
  webinyModel: WebinyModel;
}

export const addConsumerContent = async (
  request: AddConsumerContentRequest,
): Promise<unknown> => {
  const response = await post(ApiEndpoint.addConsumerContent, request);
  return response.data?.data;
};
